<template>
  <Page>
    <session class="page-home">
      <div class="block-wrap block1-wrap" id="aboutus" :style="{ backgroundImage: `url(${IMG_COVER_BANNER})` }">
        <div class="container">
          <div class="block1-content">
            <span>记录爱宠每一刻，</span>
            <span>遇见同城好狗友</span>
          </div>
        </div>
      </div>
      <div class="block-wrap block2-wrap">
        <div class="container">
          <div class="block2-about">
            <span>宠一APP是一款专为AI时代设计的应用程序，</span>
            <span>你可以为爱犬建立专属成长档案，记录疫苗驱虫、个性技能；在同城内容广场发现附近的狗友和有趣动态；还能一键找到本地认证的宠物医院、宠物店。从记录到社交，从知识到服务，让养宠生活更简单、更温暖。</span>
          </div>
        </div>
      </div>

      <div class="block-wrap block3-wrap" id="intro">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_3})` }" />
          <div class="block-content">
            <div class="title">
              <span>完整爱犬档案，健康成长一目了然</span>
            </div>
            <div class="detail">支持添加多只爱犬，必填基础信息（昵称、犬种、生日、体重、绝育情况），还可自定义性格与技能标签（如“社交牛逼症”“会接飞盘”）。健康专项模块帮你记录疫苗与驱虫周期，告别遗忘，科学养宠。</div>
          </div>
        </div>
      </div>

      <div class="block-wrap block4-wrap">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_4})` }" />
          <div class="block-content">
            <div class="title">
              <span>同城犬友圈，找到志同道合的伙伴</span>
            </div>
            <div class="detail">基于位置优先展示同城的遛狗打卡、聚会邀约、经验问答等内容。同时算法会根据你养的犬种（如哈士奇、柯基）推荐同类内容，让你轻松加入同城、同犬种的社群，线下面基不再尴尬。</div>
          </div>
        </div>
      </div>
      
      <div class="block-wrap block5-wrap">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_5})` }" />
          <div class="block-content">
            <div class="title">
              <span>本地商家服务，甄选靠谱养宠资源</span>
            </div>
            <div class="detail">商家经平台审核认证后拥有专属标识，可发布专业科普长文章、服务项目及店铺信息。用户可浏览商家列表，按分类（宠物医院、宠物店等）筛选，查看门头、地址、电话，养宠问题一站解决。</div>
          </div>
        </div>
      </div>

<!--      <div class="block-wrap block6-wrap" id="download">-->
<!--        <div class="container">-->
<!--          <div class="download-title">下载APP</div>-->
<!--          <div class="download-message">-->
<!--            <div class="download-message-l">-->

<!--              <div class="download-divice">-->
<!--                <div class="download-divice-t">-->
<!--                  <div class="download-divice-icon ios" />-->
<!--                  <div class="download-divice-name"><span>App Store</span><span>下载</span></div>-->
<!--                </div>-->
<!--                <div class="download-divice-b"><img src="./images/qrcode-ios.png" /></div>-->
<!--              </div>-->

<!--              <div class="download-divice">-->
<!--                <div class="download-divice-t">-->
<!--                  <div class="download-divice-icon android" />-->
<!--                  <div class="download-divice-name"><span>Android</span><span>下载</span></div>-->
<!--                </div>-->
<!--                <div class="download-divice-b"><img src="./images/qrcode-android.png" /></div>-->
<!--              </div>-->

<!--            </div>-->
<!--            <div class="download-message-r"><img src="./images/download-cover.png" /></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </session>
  </Page>
</template>

<script setup>
  import Page from '@/components/page';

  import IMG_COVER_BANNER from './images/banner.png';
  import IMG_COVER_3 from './images/cover3.png';
  import IMG_COVER_4 from './images/cover4.png';
  import IMG_COVER_5 from './images/cover5.png';
</script>

<style scoped lang="less">
@import "index.less";
</style>
